import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import {
  ITEM_STATUS_LABEL_KEYS,
  ITEM_STATUS_PILL,
  MOVING_ITEM_STATUSES,
} from "../../constants/payoutBatches.constants";
import type { PayoutBatchItemStatus } from "../../types/payoutBatches.types";

export interface ItemStatusPillProps {
  status: PayoutBatchItemStatus;
  className?: string;
}

/** Row lifecycle pill; queued, processing and submitted rows pulse because they are still moving. */
export function ItemStatusPill({ status, className }: ItemStatusPillProps) {
  const { t } = useTranslations("payoutBatches");
  const moving = MOVING_ITEM_STATUSES.has(status);
  return (
    <ColocaStatusPill
      variant={ITEM_STATUS_PILL[status] ?? "neutral"}
      size="sm"
      withDot
      className={cn(moving && "[&>span:first-child]:animate-pulse", className)}
    >
      {ITEM_STATUS_LABEL_KEYS[status] ? t(ITEM_STATUS_LABEL_KEYS[status]) : status}
    </ColocaStatusPill>
  );
}
